<template>
  <vs-collapse class="flex flex-col">
    <vs-collapse-item v-for="(item, i) in items"
                      :key="i"
                      :class="{ 'border-0 border-b border-solid border-soft': displayBottomBorder[i], 'pt-4': i !== 0 }"
                      class="pb-4"
                      not-arrow
                      @click.native="handleCollapse(i)"
    >
      <div slot="header" class="flex">
        <div class="w-4 mr-4">
          <img :src="displayPlusIcon[i] ? plusIcon : minusIcon"
               class="cursor-pointer"
               alt="expand icon"
               :key="refreshIcons"
          />
        </div>
        <div class="text-black-soft font-medium">{{ item.title }}</div>
      </div>
      <div class="pl-8 pt-4 leading-loose">{{ item.text }}</div>
    </vs-collapse-item>
  </vs-collapse>
</template>

<script>
import plusIcon from '@/assets/images/icons/plus.svg'
import minusIcon from '@/assets/images/icons/minus.svg'

export default {
  name: 'ExpandableList',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      plusIcon,
      minusIcon,
      displayPlusIcon: {},
      refreshIcons: 0
    }
  },

  created() {
    this.displayPlusIcon = this.items.map(i => {
      return {
        i: true
      }
    })
  },

  methods: {
    displayBottomBorder(i) {
      return i + 1 !== this.items.length
    },

    handleCollapse(i) {
      this.displayPlusIcon[i] = !this.displayPlusIcon[i]
      this.refreshIcons += 1
    }
  }
}
</script>
